/* MARSANIC VEHICLE SEARCH — see brief v48 */
/**
 * vehicle-search.js
 * Year → Make → Model cascading selector with localStorage "garage" state.
 * Loaded globally by layout/theme.liquid; initialises every .marsanic-vs root
 * present on the page once window.MARSANIC_VEHICLES is available.
 *
 * No external dependencies. No global pollution beyond window.MarsanicVS.
 */
(function () {
  'use strict';

  /* ========================================================================
   * CONFIG — change BASE_COLLECTION here to redirect the default search target
   * ======================================================================== */
  var BASE_COLLECTION = '/collections/all';
  var LS_KEY = 'marsanic_garage';
  var COLLECTION_PATH_RE = /^\/collections\/([^\/?#]+)/;

  /* ========================================================================
   * localStorage — wrapped to swallow quota / privacy-mode errors
   * ======================================================================== */
  function readGarage() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if (!parsed.key || !parsed.label) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }
  function writeGarage(obj) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(obj)); } catch (e) { /* ignore */ }
  }

  /* ========================================================================
   * Page detection
   * ======================================================================== */
  function getCurrentCollectionPath() {
    var m = (window.location.pathname || '').match(COLLECTION_PATH_RE);
    return m ? '/collections/' + m[1] : null;
  }
  function isOnCollectionPage() {
    if (!getCurrentCollectionPath()) return false;
    return !!document.querySelector('#ProductGridContainer, #product-grid');
  }
  function getActiveTagFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('filter.p.tag') || null;
    } catch (e) { return null; }
  }

  /* ========================================================================
   * Data — derived from window.MARSANIC_VEHICLES
   * ======================================================================== */
  function getEarliestYear(vehicles) {
    var min = 9999;
    for (var i = 0; i < vehicles.length; i++) {
      if (typeof vehicles[i].from === 'number' && vehicles[i].from < min) min = vehicles[i].from;
    }
    return min === 9999 ? 1989 : min;
  }
  function getCurrentYear() { return new Date().getFullYear(); }

  function vehiclesForYear(vehicles, year) {
    var out = [];
    for (var i = 0; i < vehicles.length; i++) {
      var v = vehicles[i];
      if (v.from <= year && v.to >= year) out.push(v);
    }
    return out;
  }
  function makesForYear(vehicles, year) {
    var seen = Object.create(null), list = [];
    var pool = vehiclesForYear(vehicles, year);
    for (var i = 0; i < pool.length; i++) {
      var m = pool[i].make;
      if (!seen[m]) { seen[m] = true; list.push(m); }
    }
    list.sort();
    return list;
  }
  function modelsForYearMake(vehicles, year, make) {
    var pool = vehiclesForYear(vehicles, year);
    var list = [];
    for (var i = 0; i < pool.length; i++) {
      if (pool[i].make === make) list.push(pool[i]);
    }
    list.sort(function (a, b) { return a.model.localeCompare(b.model); });
    return list;
  }

  /* ========================================================================
   * URL building — preserves current collection if on one
   * ======================================================================== */
  function buildFilterUrl(tagKey) {
    var collectionPath = getCurrentCollectionPath() || BASE_COLLECTION;
    return collectionPath + '?filter.p.tag=' + encodeURIComponent(tagKey);
  }

  /* ========================================================================
   * DOM helpers
   * ======================================================================== */
  function setOptions(selectEl, items, placeholder) {
    while (selectEl.firstChild) selectEl.removeChild(selectEl.firstChild);
    var p = document.createElement('option');
    p.value = ''; p.textContent = placeholder;
    selectEl.appendChild(p);
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var o = document.createElement('option');
      if (typeof it === 'string') {
        o.value = it; o.textContent = it;
      } else {
        o.value = it.model;        // model string is the unique-per-make-year value
        o.textContent = it.model;
        o.dataset.key = it.key;
      }
      selectEl.appendChild(o);
    }
  }

  /* ========================================================================
   * Section relocation — moves the rendered section into a different DOM
   * slot (above header / below header / above footer) based on section setting.
   * ======================================================================== */
  function relocateSection(root) {
    var pos = root.dataset.sectionPosition || 'below_header';
    if (pos === 'below_header') return;

    // The Shopify section wrapper is the immediate parent of our root
    var wrapper = root.parentElement;
    if (!wrapper) return;
    // Defensive: if our parent isn't the Shopify wrapper for some reason, climb up
    if (!wrapper.id || wrapper.id.indexOf('shopify-section-') !== 0) {
      wrapper = root.closest('[id^="shopify-section-"]') || wrapper;
    }

    if (pos === 'above_header') {
      // Find the first section that's part of the header-group
      var firstHeader = document.querySelector('.shopify-section-group-header-group')
                     || document.querySelector('header')
                     || document.querySelector('[class*="shopify-section"][id*="header"]');
      if (firstHeader && firstHeader !== wrapper && !firstHeader.contains(wrapper)) {
        // BUG FIX #1: On the homepage, Wokiee wraps header sections in
        // <fixed-headergroup class="fixed-header-group">. Inserting before
        // firstHeader would put us INSIDE that wrapper. Climb out so the
        // bar sits genuinely above the (sticky) header.
        var insertionPoint = firstHeader;
        var parent = insertionPoint.parentElement;
        while (parent && (
            parent.tagName === 'FIXED-HEADERGROUP' ||
            (parent.classList && parent.classList.contains('fixed-header-group'))
          )) {
          insertionPoint = parent;
          parent = insertionPoint.parentElement;
        }
        if (insertionPoint !== wrapper && !insertionPoint.contains(wrapper)) {
          insertionPoint.parentNode.insertBefore(wrapper, insertionPoint);
        }
      }
    } else if (pos === 'above_footer') {
      var footer = document.querySelector('.footer__content')
                || document.querySelector('footer')
                || document.querySelector('[class*="shopify-section-group-footer-group"]');
      if (footer && footer !== wrapper && !footer.contains(wrapper)) {
        footer.parentNode.insertBefore(wrapper, footer);
      }
    }
  }

  /* ========================================================================
   * Custom dropdown — animated replacement for native <select> on desktop.
   * Keeps the native <select> in the DOM (hidden) for accessibility/keyboard,
   * mirroring its options and value into a styled, animated UI.
   * ======================================================================== */
  function isMobileWidth() { return window.matchMedia('(max-width: 1024px)').matches; }

  // BUG FIX #2: One global outside-click + Escape handler covers every
  // custom dropdown on the page. Previously buildCustomDropdown attached a
  // new document.click listener per dropdown, which leaked in the theme
  // editor (shopify:section:load rebuilt dropdowns without removing old
  // listeners). Registered once on first init, never bound again.
  var __mvsGlobalHandlersBound = false;
  function bindGlobalHandlers() {
    if (__mvsGlobalHandlersBound) return;
    __mvsGlobalHandlersBound = true;
    document.addEventListener('click', function (e) {
      var open = document.querySelectorAll('.marsanic-vs__select-wrap.is-open');
      for (var i = 0; i < open.length; i++) {
        if (!open[i].contains(e.target)) {
          open[i].classList.remove('is-open');
          var btn = open[i].querySelector('.marsanic-vs__select-button');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      // Close any open custom dropdowns
      document.querySelectorAll('.marsanic-vs__select-wrap.is-open').forEach(function (w) {
        w.classList.remove('is-open');
        var btn = w.querySelector('.marsanic-vs__select-button');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      // Cancel any in-progress edits (delegates to per-section cancelEdit)
      document.querySelectorAll('.marsanic-vs--editing').forEach(function (r) {
        if (typeof r._mvsCancelEdit === 'function') r._mvsCancelEdit();
      });
    });
  }

  function buildCustomDropdown(selectEl) {
    if (selectEl.dataset.mvsEnhanced) return;
    selectEl.dataset.mvsEnhanced = '1';

    // Wrap the select in a positioning wrapper
    var wrap = document.createElement('div');
    wrap.className = 'marsanic-vs__select-wrap';
    selectEl.parentNode.insertBefore(wrap, selectEl);
    wrap.appendChild(selectEl);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'marsanic-vs__select-button';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var btnLabel = document.createElement('span');
    btnLabel.className = 'marsanic-vs__select-button-label';
    btn.appendChild(btnLabel);
    wrap.appendChild(btn);

    var list = document.createElement('ul');
    list.className = 'marsanic-vs__select-list';
    list.setAttribute('role', 'listbox');
    wrap.appendChild(list);

    function syncFromSelect() {
      // Rebuild list to reflect current options
      while (list.firstChild) list.removeChild(list.firstChild);
      var selected = selectEl.options[selectEl.selectedIndex];
      btnLabel.textContent = selected ? selected.textContent : '';
      btn.disabled = selectEl.disabled;
      for (var i = 0; i < selectEl.options.length; i++) {
        var opt = selectEl.options[i];
        // Skip the placeholder (empty-value first option) — it's already shown
        // as the button label, so duplicating it inside the list is noise.
        if (opt.value === '') continue;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.value = opt.value;
        li.textContent = opt.textContent;
        if (opt.selected) li.setAttribute('aria-selected', 'true');
        list.appendChild(li);
      }
    }

    function open() {
      if (btn.disabled) return;
      // Close any other open dropdowns first
      document.querySelectorAll('.marsanic-vs__select-wrap.is-open').forEach(function (w) {
        if (w !== wrap) w.classList.remove('is-open');
      });
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (wrap.classList.contains('is-open')) close(); else open();
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li[role="option"]');
      if (!li) return;
      selectEl.value = li.dataset.value;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      close();
    });
    // (Outside-click + global Escape handled at module level via bindGlobalHandlers)
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
      }
    });

    // Keep custom UI in sync whenever the native select changes (programmatic or user)
    selectEl.addEventListener('change', syncFromSelect);
    // Also expose a manual refresh hook for when options are repopulated
    selectEl._mvsRefreshCustom = syncFromSelect;
    syncFromSelect();
  }

  function enhanceDropdowns(root) {
    if (root.dataset.animateDropdowns !== '1') return;
    if (isMobileWidth()) return; // mobile uses native picker
    var selects = root.querySelectorAll('.marsanic-vs__select');
    for (var i = 0; i < selects.length; i++) buildCustomDropdown(selects[i]);
  }
  function refreshCustom(selectEl) {
    if (selectEl && typeof selectEl._mvsRefreshCustom === 'function') {
      selectEl._mvsRefreshCustom();
    }
  }

  /* ========================================================================
   * Section instance
   * ======================================================================== */
  function initSection(root, vehicles) {
    var yearSel  = root.querySelector('[data-mvs-year]');
    var makeSel  = root.querySelector('[data-mvs-make]');
    var modelSel = root.querySelector('[data-mvs-model]');
    var searchBtn = root.querySelector('[data-mvs-search]');
    var bar = root.querySelector('[data-mvs-bar]');
    var garageBox = root.querySelector('[data-mvs-garage]');
    var garageLabel = root.querySelector('[data-mvs-garage-label]');
    var editBtn = root.querySelector('[data-mvs-edit]');
    var clearBtn = root.querySelector('[data-mvs-clear]');
    var cancelEditBtn = root.querySelector('[data-mvs-cancel-edit]');
    var panelToggle = root.querySelector('[data-mvs-panel-toggle]');
    var panelToggleLabel = root.querySelector('[data-mvs-panel-toggle-label]');
    var overlay = root.querySelector('[data-mvs-overlay]');

    if (!yearSel || !makeSel || !modelSel || !searchBtn) return;

    // Reparent section to chosen layout slot, if not 'below_header'
    relocateSection(root);

    // Build animated custom dropdowns (desktop + setting on)
    enhanceDropdowns(root);

    var earliestYear = getEarliestYear(vehicles);
    var currentYear = getCurrentYear();
    var years = [];
    for (var y = currentYear; y >= earliestYear; y--) years.push(String(y));
    setOptions(yearSel, years, 'Year');
    refreshCustom(yearSel);

    function refreshMakes() {
      var y = parseInt(yearSel.value, 10);
      if (!y) {
        setOptions(makeSel, [], 'Make');
        makeSel.disabled = true;
        setOptions(modelSel, [], 'Model');
        modelSel.disabled = true;
        searchBtn.disabled = true;
        refreshCustom(makeSel); refreshCustom(modelSel);
        return;
      }
      setOptions(makeSel, makesForYear(vehicles, y), 'Make');
      makeSel.disabled = false;
      setOptions(modelSel, [], 'Model');
      modelSel.disabled = true;
      searchBtn.disabled = true;
      refreshCustom(makeSel); refreshCustom(modelSel);
    }

    function refreshModels() {
      var y = parseInt(yearSel.value, 10);
      var m = makeSel.value;
      if (!y || !m) {
        setOptions(modelSel, [], 'Model');
        modelSel.disabled = true;
        searchBtn.disabled = true;
        refreshCustom(modelSel);
        return;
      }
      setOptions(modelSel, modelsForYearMake(vehicles, y, m), 'Model');
      modelSel.disabled = false;
      searchBtn.disabled = true;
      refreshCustom(modelSel);
    }

    function getSelectedKey() {
      var opt = modelSel.options[modelSel.selectedIndex];
      return opt && opt.dataset ? opt.dataset.key : null;
    }

    function showGarage(garage) {
      if (!garage) return;
      garageLabel.textContent = garage.label;
      // Visibility driven by CSS class (works with both default and cross-fade states)
      root.classList.add('marsanic-vs--garage-on');
      if (panelToggleLabel) panelToggleLabel.textContent = garage.label;
    }

    function showDropdowns() {
      root.classList.remove('marsanic-vs--garage-on');
    }

    function commitAndNavigate() {
      var y = parseInt(yearSel.value, 10);
      var m = makeSel.value;
      var modelStr = modelSel.value;
      var key = getSelectedKey();
      if (!y || !m || !modelStr || !key) return;
      var label = y + ' ' + m + ' ' + modelStr;
      // savedAt timestamp powers the auto-clear (TTL) feature.
      writeGarage({ year: y, make: m, model: modelStr, key: key, label: label, savedAt: Date.now() });
      window.location.assign(buildFilterUrl(key));
    }

    // Hold a reference to the garage we're editing so Cancel can restore it
    // even if localStorage was modified mid-edit. Lives on the root node so
    // the global Escape handler can reach it via root._mvsCancelEdit.
    var _editingFromGarage = null;

    function resetToEditState() {
      _editingFromGarage = readGarage();
      if (_editingFromGarage) {
        root.classList.add('marsanic-vs--editing');
      }
      showDropdowns();
      // Reset dropdowns to empty, ready for a new selection
      yearSel.value = '';
      refreshMakes();
      // Dim grid if on a collection page
      if (isOnCollectionPage()) {
        document.body.classList.add('vehicle-filter-edit');
      }
      // Reopen panel if button+panel layout
      if (root.classList.contains('marsanic-vs--panel')) {
        root.classList.add('marsanic-vs--panel-open');
      }
    }

    function cancelEdit() {
      if (!root.classList.contains('marsanic-vs--editing')) return;
      var garage = _editingFromGarage || readGarage();
      if (garage) showGarage(garage);
      root.classList.remove('marsanic-vs--editing');
      document.body.classList.remove('vehicle-filter-edit');
      _editingFromGarage = null;
    }
    // Expose for the global Escape handler in bindGlobalHandlers()
    root._mvsCancelEdit = cancelEdit;

    /* ----- Event wiring ------------------------------------------------- */
    yearSel.addEventListener('change', function () {
      refreshMakes();
    });
    makeSel.addEventListener('change', function () {
      refreshModels();
    });
    modelSel.addEventListener('change', function () {
      var hasAll = !!(yearSel.value && makeSel.value && modelSel.value && getSelectedKey());
      searchBtn.disabled = !hasAll;
      if (hasAll && root.dataset.autoSearch === '1') {
        commitAndNavigate();
      }
    });
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!searchBtn.disabled) commitAndNavigate();
    });
    if (editBtn) {
      editBtn.addEventListener('click', function (e) {
        e.preventDefault();
        resetToEditState();
      });
    }
    if (cancelEditBtn) {
      cancelEditBtn.addEventListener('click', function (e) {
        e.preventDefault();
        cancelEdit();
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // Wipe the saved garage
        try { localStorage.removeItem(LS_KEY); } catch (err) { /* ignore */ }
        // Reset dropdowns
        showDropdowns();
        yearSel.value = '';
        refreshMakes();
        // Remove edit-state dimming if present
        document.body.classList.remove('vehicle-filter-edit');
        // If we're on a filtered collection page, drop the filter from the URL
        // (stay on the same collection, just clear ?filter.p.tag=...)
        if (getActiveTagFromUrl()) {
          window.location.assign(window.location.pathname);
        }
      });
    }
    if (panelToggle) {
      panelToggle.addEventListener('click', function (e) {
        e.preventDefault();
        root.classList.toggle('marsanic-vs--panel-open');
      });
    }
    if (overlay) {
      overlay.addEventListener('click', function () {
        root.classList.remove('marsanic-vs--panel-open');
      });
    }

    /* ----- Initial state ------------------------------------------------ */
    var garage = readGarage();
    // Auto-clear (TTL) — drop the garage if it's older than the configured
    // expiry window. ttlDays = 0 means "never expire".
    if (garage) {
      var ttlDays = parseInt(root.dataset.mvsTtlDays || '0', 10);
      if (ttlDays > 0 && typeof garage.savedAt === 'number') {
        var ageMs = Date.now() - garage.savedAt;
        if (ageMs > ttlDays * 86400000) {
          try { localStorage.removeItem(LS_KEY); } catch (err) { /* ignore */ }
          garage = null;
        }
      }
    }
    if (garage) {
      showGarage(garage);
    } else {
      showDropdowns();
      refreshMakes();
    }

    // Reveal the section now that JS has decided on garage vs dropdown state
    root.classList.add('marsanic-vs--ready');
  }

  /* ========================================================================
   * Page-level wiring (body classes for collection page behaviours)
   * ======================================================================== */
  function applyCollectionPageState() {
    var activeTag = getActiveTagFromUrl();
    if (activeTag && isOnCollectionPage()) {
      document.body.classList.add('vehicle-filter-active');
      // Animation flag — only enable if at least one section requests it.
      // Any section with data-fade-in="1" turns on the fade-in animation globally.
      var anyFade = false;
      var roots = document.querySelectorAll('.marsanic-vs');
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].dataset.fadeIn === '1') { anyFade = true; break; }
      }
      if (anyFade) document.body.classList.add('vehicle-filter-anim');
    }
  }

  /* ========================================================================
   * Vehicle-tag preservation across facet interactions
   *
   * Why this exists:
   *   Shopify Search & Discovery's Standard "Tags" facet only renders the
   *   first 100 tag values (alphabetically) into the facet form. Marsanic
   *   has 660+ vehicle tags plus brand/category tags, so most vehicle keys
   *   (e.g. "bmw-m3-g80") never appear in the form. When a customer clicks
   *   any Brand / Price facet, the form submits WITHOUT filter.p.tag and
   *   the vehicle filter is silently dropped.
   *
   * Fix: inject a hidden <input name="filter.p.tag"> into each facet form
   * mirroring the active tag from the URL, and patch facet-related links
   * (sort, remove, page) so they keep the tag. Re-run after AJAX facet
   * updates (Wokiee replaces the facet block on every change).
   * ======================================================================== */
  function preserveTagInFacetForms() {
    function injectIntoForm(form) {
      var tag = getActiveTagFromUrl();
      if (!form || !tag) return;
      // Already present and effective? (checked checkbox, or a hidden mirror)
      var inputs = form.querySelectorAll('input[name="filter.p.tag"]');
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        if (inp.value === tag) {
          if (inp.type === 'checkbox' || inp.type === 'radio') {
            if (!inp.checked) inp.checked = true;
            return;
          }
          if (inp.type === 'hidden') return;
        }
      }
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'filter.p.tag';
      hidden.value = tag;
      hidden.setAttribute('data-marsanic-preserve-tag', '1');
      form.appendChild(hidden);
    }

    function syncAllForms() {
      var forms = document.querySelectorAll('form[id^="FacetFilters"]');
      for (var i = 0; i < forms.length; i++) injectIntoForm(forms[i]);
    }

    function patchLink(a) {
      if (!a || !a.href || a.dataset.marsanicTagPatched === '1') return;
      var tag = getActiveTagFromUrl();
      if (!tag) return;
      var href;
      try { href = new URL(a.href, window.location.origin); } catch (_) { return; }
      if (href.pathname !== window.location.pathname) return;
      // Only patch URLs that already carry filter.* / sort_by / page params
      var relevant = false;
      href.searchParams.forEach(function (_, k) {
        if (k.indexOf('filter.') === 0 || k === 'sort_by' || k === 'page') relevant = true;
      });
      if (!relevant) return;
      if (!href.searchParams.has('filter.p.tag')) {
        href.searchParams.set('filter.p.tag', tag);
        a.href = href.toString();
        a.dataset.marsanicTagPatched = '1';
      }
    }

    function patchAllLinks() {
      // Sort dropdown, active-facets remove pills, pagination, facet links
      var links = document.querySelectorAll(
        'a[href*="filter."], a[href*="sort_by="], a[href*="page="], #active-facets a, .active-facets a'
      );
      for (var i = 0; i < links.length; i++) patchLink(links[i]);
    }

    function syncAll() {
      syncAllForms();
      patchAllLinks();
    }

    syncAll();

    // Wokiee re-renders the #FacetFiltersForm subtree after every filter
    // change (AJAX). Re-inject when the DOM changes.
    if (window.MutationObserver) {
      var observer = new MutationObserver(function () { syncAll(); });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Defensive: also patch on click for any links we may have missed.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a');
      if (a) patchLink(a);
    }, true);
  }

  /* ========================================================================
   * Bootstrap — wait for vehicle data, then init each section instance
   * ======================================================================== */
  function whenVehiclesReady(cb) {
    if (window.MARSANIC_VEHICLES && window.MARSANIC_VEHICLES.length) return cb();
    var tries = 0;
    var t = setInterval(function () {
      if (window.MARSANIC_VEHICLES && window.MARSANIC_VEHICLES.length) {
        clearInterval(t);
        cb();
      } else if (++tries > 200) {
        // ~5s with 25ms steps — give up silently to avoid breaking the page
        clearInterval(t);
      }
    }, 25);
  }

  function bootstrap() {
    // Tag preservation runs even without a vehicle-search section on the page,
    // so deep-linked filter URLs survive facet clicks regardless.
    applyCollectionPageState();
    preserveTagInFacetForms();
    var roots = document.querySelectorAll('.marsanic-vs');
    if (!roots.length) return;
    bindGlobalHandlers();
    whenVehiclesReady(function () {
      for (var i = 0; i < roots.length; i++) initSection(roots[i], window.MARSANIC_VEHICLES);
    });
    // BUG FIX #3: When the viewport crosses the mobile/desktop threshold,
    // build any custom dropdowns that weren't built at load time.
    var mql = window.matchMedia('(max-width: 1024px)');
    var onChange = function (e) {
      if (e.matches) return; // entering mobile — CSS hides custom UI; nothing to do
      // Crossed into desktop range — build any custom dropdowns we hadn't built yet
      document.querySelectorAll('.marsanic-vs').forEach(function (root) {
        if (window.MARSANIC_VEHICLES) enhanceDropdowns(root);
      });
    };
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange); // Safari < 14
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-init when Shopify theme editor injects/updates the section live
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.marsanic-vs');
    if (!root) return;
    applyCollectionPageState();
    whenVehiclesReady(function () { initSection(root, window.MARSANIC_VEHICLES); });
  });

  // Expose a small namespace for debugging — no public API surface beyond this
  window.MarsanicVS = {
    BASE_COLLECTION: BASE_COLLECTION,
    LS_KEY: LS_KEY,
    readGarage: readGarage
  };
})();
